import React from 'react'
import {SVNumber,SVNArray, SVStringEp, SVDate, SVEDDInputEp,SVIDDInputEp,SVNAOInputEp,SVVCOInputEp,SVICOInputEp ,SVBPInputEp, SVILInputEp,SVDNInputEp} from '../core'

import {   Field} from 'redux-form'

/*svj21 start */

//import {SVNumber,SVNArray, SVString,SVStringEp, SVDate, SVInput, SVInputEp, SVICInputEp,SVBPInputEp, SVILInputEp,SVVCInputEp, SVNAInputEp,SVDNInputEp, SVEDInputEp} from '../core'
/*svj21 end */

  class SVADocComponentEp extends React.Component{
    

    constructor(props){
        super(props)
        this.svDDChange = this.svDDChange.bind(this)
        this.svfieldType=  this.props.portType || 'CL_String'
        this.state={
            svfieldType: this.props.portType || 'CL_String'
        }
        this.getCoreComponent = this.getCoreComponent.bind(this)


    }
    componentWillReceiveProps(next){
        console.log(next)

    }

    getCoreComponent(fieldType, member, index, placeholderString){
        console.log('sv--fieldType^^^^^^^^^^^^^^^^^^^^^^^^^^^^')
        console.log(fieldType)
        let svview  =  (<SVStringEp svfieldType={fieldType}   member={member} index={index} placeholder={placeholderString}> </SVStringEp>) 
        switch(fieldType){
            case 'CL_String':
            svview  =  (<SVStringEp svfieldType={fieldType}   member={member} index={index} placeholder={placeholderString}> </SVStringEp>) 
           // svview = 
            break
            case 'CL_Number':
            svview = (  <SVNumber svfieldType={fieldType}  member={member} index={index} placeholder="Port X" > </SVNumber>)
            break
            case 'CL_Date':
            svview = ( <SVDate svfieldType={fieldType}  portId={`${member}.issuanceDate`} > </SVDate>)
            break
            case 'CL_NArray':
            svview  =  (<SVNArray svfieldType={fieldType}   member={member} index={index} placeholder="21,34,35"> </SVNArray>) 
            break

        }

        return svview
        
    }
    svDDChange(e){
        //this.refs.DropdownList.refs
        //this.refs.DropdownList.refs.inner.handleClick()
        console.log(e)

        //ob.target.value
        if(e.target.value =='string'){
            console.log('sv change action to change class')
           // this.props.initialValues.gene
            this.svfieldType= 'CL_String'
        }else if(e.target.value == 'date'){
            this.svfieldType= 'CL_Date'
        }else if(e.target.value == 'narray'){
            this.svfieldType= 'CL_NArray'    

        }else{
            this.svfieldType= 'CL_Number'
        }

        this.setState({
            svfieldType:this.svfieldType
        })

    }
/*
"documents": [
        {
            
            "documentType": "IDENTITY_CARD",
            "birthPlace": "Madrid",
            "issuanceLocation": "Madrid",
            "issuanceDate": "2015-04-13",
            "documentNumber": "00000069",
            "expiryDate": "2025-04-13",
            "issuanceCountry": "ES",
            "validityCountry": "ES",
            "nationality": "ES",
            "holder": "Y"
           
            
        }
    ],
*/
    render(){
        let me = this
        let issuanceDate_fieldType = 'CL_Date'
        let expiryDate_fieldType = 'CL_Date'
        //  this.props.initialValues.svfieldType= 'CL_String'
        console.log(this.props)
        const {member, index, portTypes, holderTypes,documentTypes,locationTypes, inputSchemaTypes}= this.props
        console.log(member)
          /*svj21 start*/
          const {countryTwoTypes} = this.props
          console.log("*******svj2****ADoc countryTwoTypes** START")
          console.log(countryTwoTypes)

          console.log("*******svj2****ADevice** END")

            /*svj21 end*/
       // const  {svshow,  svhide, portId, portName, portTypes, locationId, locationText,locationTypes,  children} = this.props
       // const portEntryId="sv"+portId
        const svfieldType = this.state.svfieldType
       

      
        return ( 
        <div className="box-block">  
       
       <div className="form-group">
                <label htmlFor={`${member}.documentType`}  > Document Type <span class="svr-required">*</span></label>
                <Field  component="select" id={`${member}.documentType`}   name={`${member}.documentType`} className="form-control" >
                
                    <option value="">Select Document Type</option>
                    {
        
                
        documentTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                    
                    
                    
                   
                )}
        
                </Field>
       </div>
       <div className="form-group">
              <label className="svform-label" htmlFor="`${member}.birthPlace`" > Birth Place<span class="svr-required">*</span></label>
              <SVBPInputEp member={member} index={index} placeholder="Port X" /> 
             
            
        </div>  
        <div className="form-group">
              <label className="svform-label" htmlFor="`${member}.issuanceLocation`" >Issuance Location<span class="svr-required">*</span></label>
              <SVILInputEp member={member} index={index} placeholder="Madrid" /> 
            
        </div>  
        <div className="form-group">
              <label className="svform-label" htmlFor="`${member}.issuanceDate`" > Issuance Date<span class="svr-required">*</span></label>
             {/*   <SVDate svfieldType={issuanceDate_fieldType}  portId={`${member}.issuanceDate`} > </SVDate>

              <SVIDDInputEp member={member} index={index} placeholder="2015-04-13" /> 
               <SVIDInputEp member={member} index={index} placeholder="2015-04-13" /> 

              

      */} 
          <SVIDDInputEp member={member} index={index} placeholder="2015-04-13" /> 

                   
        </div>  
        <div className="form-group">
              <label className="svform-label" htmlFor="`${member}.documentNumber`" > Document Number<span class="svr-required">*</span></label>
              <SVDNInputEp member={member} index={index} placeholder="00000069" /> 
            
        </div>  
        <div className="form-group">
                <span>Do not click X on date pickers.It removes date</span>
              <label className="svform-label" htmlFor="`${member}.expiryDate`" > Expiry Date(yyyy-mm-dd)<span class="svr-required">*</span></label>
             {/* 
                 <SVEDInputEp member={member} index={index} placeholder="2027-04-13" />
             */} 
            

             <SVEDDInputEp member={member} index={index} placeholder="2035-04-13" /> 
              

             
        </div>  
        <div className="form-group">
              <label className="svform-label" htmlFor="`${member}.issuanceCountry`" > Issuance Country<span class="svr-required">*</span></label>
               {/* 
                        <SVICInputEp member={member} index={index} placeholder="ES" /> 
                        
                          
                        */}
              <SVICOInputEp countryTwoTypes={countryTwoTypes} member={member} index={index} placeholder="ES" /> 
            
        </div>  
        <div className="form-group">
              <label className="svform-label" htmlFor="`${member}.validityCountry`" > Validity Country<span class="svr-required">*</span></label>
               {/* 
                        <SVVCInputEp member={member} index={index} placeholder="ES" /> 
                         
                          
                        */}
                 <SVVCOInputEp countryTwoTypes={countryTwoTypes} member={member} index={index} placeholder="ES" /> 
            
            
        </div>  
        <div className="form-group">
              <label className="svform-label" htmlFor="`${member}.nationality`" > Nationality<span class="svr-required">*</span></label>
               {/* 
                        <SVNAInputEp member={member} index={index} placeholder="ES" /> 
                        
                          
                        */}
              <SVNAOInputEp countryTwoTypes={countryTwoTypes} member={member} index={index} placeholder="ES" /> 
            
        </div>  
        <div className="form-group">
                <label htmlFor={`${member}.holder`}  > I Am Owner Of Document<span class="svr-required">*</span></label>
                <Field  component="select" id={`${member}.holder`}   name={`${member}.holder`} className="form-control" >
                
                    <option value="">Select Holder Type for (Port)  </option>
                    {
        
                
        holderTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                    
                    
                    
                   
                )}
        
                </Field>
        </div>



        
               
    
        
        
       
        </div>     )


    }
}

export default SVADocComponentEp